import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Button, IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { BookingService } from "../../services/bookings.service";
import BookingEditForm from "../../components/bookings/BookingEditForm";
import Loader from "../../components/common/Loader";

const BookingEditPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const load = async () => {
            try {
                const data = await BookingService.getBooking(id);
                setBooking(data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id]);

    const handleChange = (field, value) => {
        setBooking(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await BookingService.updateBooking(booking.id, booking);
            navigate(-1); // Go back
        } catch (e) {
            alert("Failed to save");
            console.error(e);
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <Loader />;
    if (!booking) return <Typography>Booking not found</Typography>;

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <IconButton onClick={() => navigate(-1)} sx={{ mr: 2 }}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
                    Edit Booking - {booking.id}
                </Typography>
                <Button variant="contained" color="success" onClick={handleSave} disabled={saving}>
                    {saving ? 'Saving...' : 'Save Changes'}
                </Button>
            </Box>

            <BookingEditForm booking={booking} onChange={handleChange} />
        </Box>
    );
};

export default BookingEditPage;
